import { apiURl } from "../configuration/apiconfig";
import { fetchAndReturn } from "../utils/utility";

const getTablesOverviewRequest = (token) => {
  const organizationId = localStorage.getItem("organizationId");
  const url =
    apiURl + "dashboard/gettablesoverview?organizationId=" + organizationId;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const getDailyTurnOverRequest = (token, startDate, endDate) => {
  const organizationId = localStorage.getItem("organizationId");
  const url =
    apiURl +
    "dashboard/dailyturnover?organizationId=" +
    organizationId +
    `&startDate=${startDate}&endDate=${endDate}`;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const getDailyReportForRangeRequest = (token) => {
  const organizationId = localStorage.getItem("organizationId");
  const url =
    apiURl + "dashboard/dailyReportForRange?organizationId=" + organizationId;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const getAllRestauranstsRequest = (token, orgId) => {
  const organizationId =
    orgId != null ? orgId : localStorage.getItem("organizationId");
  const url = apiURl + "restaurants?organizationId=" + organizationId;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const getUserOrganizationsRequest = (token) => {
  const url = apiURl + "organizations/getuserorganizations";
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const getDailyTurnoverForPast4DaysByRestaurantsRequest = (token) => {
  const organizationId = localStorage.getItem("organizationId");
  const url =
    apiURl +
    "dashboard/DailyTurnoverForPast4DaysByRestaurants?organizationId=" +
    organizationId;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const getHouseKeepingStatisticsRequest = (token) => {
  const organizationId = localStorage.getItem("organizationId");
  const url = `${apiURl}dashboard/GetHouseKeepingStatistics?organizationId=${organizationId}`;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const getPopularHoursRequest = (token, dayOfWeek) => {
  const organizationId = localStorage.getItem("organizationId");
  const url =
    apiURl +
    "dashboard/GetPopularHours?organizationId=" +
    organizationId +
    "&DayOfWeek=" +
    dayOfWeek.dayOfWeek;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

export {
  getTablesOverviewRequest,
  getDailyTurnOverRequest,
  getDailyReportForRangeRequest,
  getAllRestauranstsRequest,
  getDailyTurnoverForPast4DaysByRestaurantsRequest,
  getUserOrganizationsRequest,
  getHouseKeepingStatisticsRequest,
  getPopularHoursRequest,
};
